module.exports = __webpack_public_path__ + "static/media/appointmentsTable.979ae89a.jpg";